import _ from 'underscore';
import AdminConstants from 'constants/AdminConstants';
import registerStore from 'utils/StoreUtils';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import PayoutCollection from './entities/payout-collection';
var ActionTypes = AdminConstants.ActionTypes;
var CHANGE_EVENT = AdminConstants.collectionChangeEvents;
var selectedPayout = null;
var payoutCollection = new PayoutCollection();
var payouts = function () {
    return payoutCollection.toJSON();
};
var watchedPayouts = new PayoutCollection();
const PayoutStore = {
    // Public API: Getters (used by controller-views)
    getPayout: function (id) {
        var payout = payoutCollection.get(id);
        if (!payout)
            return null;
        return payout.toJSON();
    },
    getAllPayouts: function () {
        return payouts();
    },
    getPayoutsByCarrier: function (carrier) {
        return _.where(payouts(), { carrier: carrier });
    },
    getWatchedPayouts: function () {
        return watchedPayouts.toJSON();
    },
    getSelectedPayout: function () {
        return selectedPayout;
    },
    // Public API: Handler Registration
    register: function (callback) {
        payoutCollection.on(CHANGE_EVENT, callback);
    },
    unregister: function (callback) {
        payoutCollection.off(CHANGE_EVENT, callback);
    },
    // Event Handlers for Dispatcher (unpack action and call Public API)
    onReceivePayouts: function (action) {
        payoutCollection.reset(action.data);
    },
    onReceivePayout: function (action) {
        const payout = action.data;
        let current;
        if (payoutCollection.length === 1 &&
            payoutCollection.at(0).id === payout._id) {
            current = payoutCollection.at(0);
            payout.carrier = current.get('carrier');
            payout.jobs = current.get('jobs');
        }
        payoutCollection.set([payout], { remove: false });
        payoutCollection.trigger(CHANGE_EVENT);
    },
    onWatchPayout: function (action) {
        selectedPayout = action.data;
        watchedPayouts.add(selectedPayout);
    },
    onUnwatchPayout: function (action) {
        watchedPayouts.remove(action.data);
    },
    onAddPayouts: function (action) {
        payoutCollection.reset(payoutCollection.toJSON().concat(action.data));
    },
};
var handlers = {};
handlers[ActionTypes.RECEIVE_PAYOUTS] = 'onReceivePayouts';
handlers[ActionTypes.RECEIVE_PAYOUT] = 'onReceivePayout';
handlers[ActionTypes.WATCH_PAYOUT] = 'onWatchPayout';
handlers[ActionTypes.UNWATCH_PAYOUT] = 'onUnwatchPayout';
handlers[ActionTypes.ADD_PAYOUTS] = 'onAddPayouts';
registerStore(PayoutStore, AdminAppDispatcher, handlers);
export default PayoutStore;
